<template>
  <div>
    <v-row>
      <v-col>
        <v-btn class="ma-2" color="primary" @click="onCreate()">Создать</v-btn>
      </v-col>
    </v-row>
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th>Id</th>
            <th>Логин</th>
            <th>Роль</th>
            <th>Имя</th>
            <th>Email</th>
            <th>Активность</th>
            <th align="center">Действия</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="user in model" v-bind:key="user.id">
            <td>{{ user.id }}</td>
            <td>{{ user.login }}</td>
            <td>{{ user.role }}</td>
            <td>{{ user.name }}</td>
            <td>{{ user.email }}</td>
            <td>
              <wapi-status v-model="user.is_active" />
            </td>
            <td>
              <v-btn @click="onEdit(user)" small color="primary">Изменить</v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-dialog v-model="dialog" max-width="290" @input="onClose()">
      <v-card>
        <v-card-title class="headline">Пользователь</v-card-title>
        <v-card-text>
          <v-container fluid>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-text-field
                v-model="currentUser.login"
                label="Логин"
                :rules="[rules.required, exRules.existLogin]"
                required
                outlined
                dense
              ></v-text-field>
              <v-text-field
                v-model="currentUser.email"
                :rules="[rules.required, rules.email, exRules.existEmail]"
                label="E-mail"
                required
                outlined
                dense
              ></v-text-field>
              <v-text-field
                v-model="currentUser.name"
                :rules="[rules.required]"
                label="Имя пользователя"
                required
                outlined
                dense
              ></v-text-field>
              <!-- <v-text-field
                    v-model="currentUser.role"
                    :rules="[rules.required]"
                    label="Роль"
                    required
                    outlined
                    dense
              ></v-text-field>-->
              <v-select
                v-model="currentUser.role"
                :items="roles"
                :rules="[rules.required]"
                label="Роль"
                dense
                outlined
              ></v-select>
              <v-text-field
                v-model="currentUser.password"
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show1 ? 'text' : 'password'"
                name="input-10-1"
                label="Пароль"
                @click:append="show1 = !show1"
                outlined
                dense
              ></v-text-field>
              <v-text-field
                v-model="currentUser.password_confirm"
                :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show2 ? 'text' : 'password'"
                name="input-10-1"
                label="Пароль (подтверждение)"
                @click:append="show2 = !show2"
                :rules="[exRules.matchPassword]"
                outlined
                dense
              ></v-text-field>
              <v-checkbox v-model="currentUser.is_active" :label="`Активность`" outlined dense></v-checkbox>
            </v-form>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text @click="cancel">Закрыть</v-btn>

          <v-btn color="green darken-1" text @click="save">Сохранить</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import User from "../models/user.js";
import rules from "../models/helpers/rules";
import WapiStatus from "./WapiStatus";

export default {
  name: "UserList",
  components: {
    WapiStatus
  },
  props: {
    model: Array
  },
  data: function() {
    return {
      valid: true,
      currentUser: {},
      dialog: false,
      show1: false,
      show2: false,
      editedId: "",
      editedLogin: "",
      editedEmail: "",
      editedName: "",
      editedRole: "",
      editedPassword: "",
      editedPasswordConfirm: "",
      editedIsActive: false,
      rules: rules,
      exRules: {
        matchPassword: () => {
          if (!this.currentUser.password_confirm && !this.currentUser.password)
            return true;
          return (
            this.currentUser.password_confirm === this.currentUser.password ||
            "Пароли должны совпадать."
          );
        },
        existLogin: value => {
          if (this.currentUser.id) {
            return true;
          }
          return (
            !this.users.find(x => x.login === value) || "Логин уже существует!"
          );
        },
        existEmail: value => {
          if (this.currentUser.id) {
            return true;
          }
          return (
            !this.users.find(x => x.email === value) || "E-mail уже существует!"
          );
        }
      }
    };
  },
  computed: {
    users() {
      return this.$store.getters.USERS;
    },
    roles() {
      return this.$store.getters.USERS.map(x => x.role);
    }
  },
  methods: {
    onEdit(user) {
      this.currentUser = this.$store.getters.USER_BY_ID(user.id);
      this.edit();
    },
    edit() {
      this.editedId = this.currentUser.id;
      this.editedLogin = this.currentUser.login;
      this.editedEmail = this.currentUser.email;
      this.editedName = this.currentUser.name;
      this.editedRole = this.currentUser.role;
      this.editedPassword = this.currentUser.password;
      this.editedPasswordConfirm = this.currentUser.password_confirm;
      this.editedIsActive = this.currentUser.is_active;
      this.dialog = true;
      this.$refs.form.resetValidation();
    },
    async save() {
      if (!this.$refs.form.validate()) return;

      await this.$store.dispatch("SET_LOADING", true);
      if (this.currentUser.id) {
        const result = await this.$store.dispatch(
          "UPDATE_USER",
          this.currentUser
        );
        if (result) this.dialog = false;
      } else {
        const result = await this.$store.dispatch(
          "CREATE_USER",
          this.currentUser
        );
        if (result) this.dialog = false;
      }
      await this.$store.dispatch("SET_LOADING", false);
    },
    onClose() {
      this.$refs.form.resetValidation();
    },
    cancel() {
      this.currentUser.id = this.editedId;
      this.currentUser.login = this.editedLogin;
      this.currentUser.email = this.editedEmail;
      this.currentUser.name = this.editedName;
      this.currentUser.role = this.editedRole;
      this.currentUser.password = this.editedPassword;
      this.currentUser.password_confirm = this.editedPasswordConfirm;
      this.currentUser.is_active = this.editedIsActive;
      this.$refs.form.resetValidation();
      this.dialog = false;
    },
    onCreate() {
      this.currentUser = new User();
      this.edit();
    }
  }
};
</script>